// extracted by mini-css-extract-plugin
export default {"errorModal":"errorModal_errorModal__OiKgY","card":"errorModal_card__9qqDm","warn":"errorModal_warn__06nZm","close":"errorModal_close__ODPoi"};